import { useState, useEffect } from 'react';
import { DateInputOld2 as DateInput2 } from '../../../../common/Input';

//icons
import CloseIcon from '@mui/icons-material/Close';

export function FamilyAddForm({
  isOpen,
  onClose,
  employeeId,
  addEmployeesFamily }) {
  const [name, setName] = useState('');
  const [dateOfBirth, setDateOfBirth] = useState('');
  const [occupation, setOccupation] = useState('');
  const [contactNumber, setContactNumber] = useState('');
  const [age, setAge] = useState('');
  const [address, setAddress] = useState('');
  const [relationship, setRelationship] = useState('');

  const handleSubmit = () => {
    
    if (!name
    ) {
      alert("Required to fill up atleast the 'Name' data");
      return; // Exit early if fields are empty
    }

    addEmployeesFamily(employeeId, name, dateOfBirth, occupation, contactNumber, age, address, relationship);
    // Clear form fields
    setName('');
    setDateOfBirth('');
    setOccupation('');
    setContactNumber('');
    setAge('');
    setAddress('');
    setRelationship('');
  };

  const handleClose = () => {
    onClose();
    setName('');
    setDateOfBirth('');
    setOccupation('');
    setContactNumber('');
    setAge('');
    setAddress('');
    setRelationship('');
  }

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div id="family-form" className="add-employees-form">
              <div className="popUp-header row">
                <div className='popUp-title'><h3 style={{ color: "#668fca" }}>Add Family</h3></div>
                <div className='popUp-close'><CloseIcon onClick={() => handleClose()} /></div>
              </div>
              <div className="popUp-body">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Name</div>
                  <div className="info-item-input"><input id="AddEmployee-Family-Name" placeholder="Name" onChange={(e) => setName(e.target.value)} /></div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date Of Birth</div>
                  <div className="info-item-input"><DateInput2 id="Family-DateOfBirth" value={dateOfBirth} onChange={(value) => setDateOfBirth(value)} /></div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Occupation</div>
                  <div className="info-item-input"><input id="AddEmployee-Family-Occupation" placeholder="Occupation" onChange={(e) => setOccupation(e.target.value)} /></div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Contact Number</div>
                  <div className="info-item-input"><input id="AddEmployee-Family-ContactNumber" placeholder="Contact Number" onChange={(e) => setContactNumber(e.target.value)} /></div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Age</div>
                  <div className="info-item-input"><Age2 id="Family-Age" value={age} onChange={(value) => setAge(value)} /></div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Relationship</div>
                  <div className="info-item-input"><input id="AddEmployee-Family-Relationship" placeholder="Relationship" onChange={(e) => setRelationship(e.target.value)} /></div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Address</div>
                  <div className="info-item-input"><input id="AddEmployee-Family-Address" placeholder="Address" onChange={(e) => setAddress(e.target.value)} /></div>
                </div>
                <div className="family-tab-footer tab-footer">
                  <div className="buttons row" style={{ justifyContent: "end" }}>
                    <button id="add-family"
                      className="save row"
                      onClick={handleSubmit}>
                      SAVE
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  )
}
export function FamilyEditForm({
  isOpen,
  onClose,
  editData,
  employeeId,
  addEmployeesFamily }) {
  const [name, setName] = useState('');
  const [dateOfBirth, setDateOfBirth] = useState('');
  const [occupation, setOccupation] = useState('');
  const [contactNumber, setContactNumber] = useState('');
  const [age, setAge] = useState('');
  const [address, setAddress] = useState('');
  const [relationship, setRelationship] = useState('');

  const handleSubmit = () => {
    
    if (!name
    ) {
      alert("Required to fill up atleast the 'Name' data");
      return; // Exit early if fields are empty
    }

    addEmployeesFamily(employeeId, name, dateOfBirth, occupation, contactNumber, age, address, relationship);
    // Clear form fields
    setName('');
    setDateOfBirth('');
    setOccupation('');
    setContactNumber('');
    setAge('');
    setAddress('');
    setRelationship('');
  };
  const handleClose = () => {
    onClose();
    setName('');
    setDateOfBirth('');
    setOccupation('');
    setContactNumber('');
    setAge('');
    setAddress('');
    setRelationship('');
  }
  useEffect(() => {
    if (isOpen) {
      setName(editData.name);
      setDateOfBirth(editData.dateOfBirth);
      setOccupation(editData.occupation);
      setContactNumber(editData.contactNumber);
      setAge(editData.age);
      setAddress(editData.address);
      setRelationship(editData.relationship);
    }
  }, [isOpen, editData]);

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div id="family-form" className="add-employees-form">
              <div className="popUp-header row">
                <div className='popUp-title'><h3 style={{ color: "#668fca" }}>Add Family</h3></div>
                <div className='popUp-close'><CloseIcon onClick={() => handleClose()} /></div>
              </div>
              <div className="popUp-body">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Name</div>
                  <div className="info-item-input"><input value={name} id="AddEmployee-Family-Name" placeholder="Name" onChange={(e) => setName(e.target.value)} /></div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date Of Birth</div>
                  <div className="info-item-input"><DateInput2 id="Family-DateOfBirth" value={dateOfBirth} onChange={(value) => setDateOfBirth(value)} /></div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Occupation</div>
                  <div className="info-item-input"><input value={occupation} id="AddEmployee-Family-Occupation" placeholder="Occupation" onChange={(e) => setOccupation(e.target.value)} /></div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Contact Number</div>
                  <div className="info-item-input"><input value={contactNumber} id="AddEmployee-Family-ContactNumber" placeholder="Contact Number" onChange={(e) => setContactNumber(e.target.value)} /></div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Age</div>
                  <div className="info-item-input"><input value={age} id="AddEmployee-Family-Age" placeholder="Age" onChange={(e) => setAge(e.target.value)} /></div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Relationship</div>
                  <div className="info-item-input"><input value={relationship} id="AddEmployee-Family-Relationship" placeholder="Relationship" onChange={(e) => setRelationship(e.target.value)} /></div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Address</div>
                  <div className="info-item-input"><input value={address} id="AddEmployee-Family-Address" placeholder="Address" onChange={(e) => setAddress(e.target.value)} /></div>
                </div>
                <div className="family-tab-footer tab-footer">
                  <div className="buttons row" style={{ justifyContent: "end" }}>
                    <button id="add-family"
                      className="save row"
                      onClick={handleSubmit}>
                      SAVE
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  )
}

function Age2({id, value, onChange}){
  const [age, setAge] = useState("");

  const handleAgeChange = (event) => {
      const value = parseInt(event.target.value);
      onChange(value);
      setAge(isNaN(value) ? '' : value); // Ensure value is a number or empty string
  };

  return (
      <div>
          <input
              type="number"
              id={"AddEmployee-" + id}
              name="age"
              value={age}
              placeholder="Age"
              onChange={handleAgeChange}
              style={{
                  width: "90%",
                  height: "30px",
                  borderRadius: "3px",
                  border: "1px solid #80808080",
                  color: "rgb(104, 104, 104)"
              }}
          />
      </div>
  );
}